export default __webpack_public_path__ + "static/media/beautiful-stories.6c250ef5.jpg";